import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Col, Row, Container } from "reactstrap";
import { Link, Element } from "react-scroll";
import { ThemeProps } from "@/shared/prop-types/ReducerProps";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Modal from "@/shared/components/Modal";
import icon from "@/assets/logo/logoPriorityCouriers.png"

const Landing = () => {
  const [isAuthorized, setIsAuthorized] = useState(true);
  return (
    <div className="landing">
      <div className="landing__menu">
        {!isAuthorized && (
          <Modal
            color="danger"
            btn="Danger"
            title="Not Authorized!"
            toggle={() => setIsAuthorized(true)}
            isSuggetion
            message="You are not an authorized user."
          // header
          />
        )}
        <Container>
          <Row>
            <Col>
              <div className="landing__menu-wrap">
                <div className="landing__menu-logo">
                  <img
                    // src={`${"https://res.cloudinary.com/wogd/image/upload/v1674732888/client/ht/global/media/content/lennhzrrsuz1ktbn65td.jpg"}`}
                    src={icon}
                    alt=""
                    height={"100px"}
                  />
                </div>
                <nav className="landing__menu-nav">
                  <div className="landing__menu-nav--button">
                    <Link
                      activeClass="active"
                      to="about"
                      spy
                      smooth
                      duration={500}
                    >
                      <button type="button">Intra-Source?</button>
                    </Link>
                  </div>
                  <div>
                    <a
                      className="landing__btn landing__btn--nav landing__btn--hire-us"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.pc.com/contact?utm_source=pc-admin_landing&utm_medium=referral&utm_campaign=templates#hireus"
                    >
                      Emergency Contact
                    </a>
                  </div>
                </nav>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Header setIsAuthorized={setIsAuthorized} />
      <Element name="about" />
      <Footer />
    </div>
  );
};

Landing.propTypes = {
  dispatch: PropTypes.func.isRequired,
  theme: ThemeProps.isRequired,
};

export default connect((state) => ({ theme: state.theme }))(Landing);
